// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__B58N8","topBottomGutter":"Layout_topBottomGutter__bDml5"};